import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const LoginComponent = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [checkingToken, setCheckingToken] = useState(true);

    useEffect(() => {
        if (localStorage.getItem("token")) {
            window.location.href = "/admin/speisekarten";
        } else {
            setCheckingToken(false);
        }
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post("/api/public/auth/login", {
                email,
                password,
            });
            localStorage.setItem("token", response.data.token);
            window.location.href = "/admin/speisekarten"; // Komplettes Reload für Header-Update
        } catch (err) {
            setError(err.response?.data?.message || "Login failed");
        }
    };

    if (checkingToken) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-white to-indigo-100">
                <div className="flex flex-col items-center">
                    <svg
                        className="animate-spin h-10 w-10 text-indigo-600 mb-4"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                        ></circle>
                        <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8z"
                        ></path>
                    </svg>
                    <span className="text-gray-600">Wird geprüft...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-white to-indigo-100">
            <div className="bg-white/90 shadow-2xl rounded-2xl p-10 w-full max-w-md border border-gray-100">
                <div className="flex flex-col items-center mb-6">
                    <img src="/logo192.png" alt="Logo" className="h-14 mb-2" />
                    <h2 className="text-3xl font-extrabold text-gray-800 mb-1 tracking-tight">
                        Login
                    </h2>
                    <p className="text-gray-500 text-sm">
                        Admin-Bereich En Edem
                    </p>
                </div>
                {error && (
                    <p className="text-red-500 text-sm text-center mb-4">
                        {error}
                    </p>
                )}
                <form onSubmit={handleLogin} className="space-y-6">
                    <div>
                        <label
                            htmlFor="email"
                            className="block text-sm font-medium text-gray-700 mb-1"
                        >
                            E-Mail-Adresse
                        </label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            autoComplete="username"
                            className="mt-1 block w-full rounded-lg border border-gray-300 bg-gray-50 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 text-base px-4 py-2 transition"
                        />
                    </div>
                    <div>
                        <label
                            htmlFor="password"
                            className="block text-sm font-medium text-gray-700 mb-1"
                        >
                            Passwort
                        </label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            autoComplete="current-password"
                            className="mt-1 block w-full rounded-lg border border-gray-300 bg-gray-50 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 text-base px-4 py-2 transition"
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 px-4 rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2 transition"
                    >
                        Login
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginComponent;
